module.exports = __webpack_public_path__ + "static/kereszty_digitezaleahnheilkunde-e9ad3da5bd74706d3a18dbfe5112d263.jpg";